import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import CardActionArea from '@material-ui/core/CardActionArea';
import ReactDOM from 'react-dom';
import { loadStripe } from '@stripe/stripe-js';

import { auth } from "./base";
const stripePromise = loadStripe('pk_test_51HkBr2I92OvN7Cbm8k4ASqWGsFNuSBOGvqlSGgupa9ZuVXrFWMDBXB0u88OzaSmLT3Zx1jyreYZxib2LNL3mgqKW00NdZWNQuj');
function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://aurafare.com/">
        aurafare.com
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
    },
  },
  appBar: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  toolbar: {
    flexWrap: 'wrap',
  },
  toolbarTitle: {
    flexGrow: 1,
  },
  link: {
    margin: theme.spacing(1, 1.5),
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6),
  },
  cardHeader: {
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
  },
  root: {
    maxWidth: 345,
  },
  media: {
    height: 200,

  },
  purchase: {
    borderRadius: '25px',
    background: 'linear-gradient(63deg, rgba(77,190,223,1) 0%, rgba(14,42,81,1) 100%)',
  },
  cardPricing: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: theme.spacing(2),
  },
  footer: {
    borderTop: `1px solid ${theme.palette.divider}`,
    marginTop: theme.spacing(8),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(6),
      paddingBottom: theme.spacing(6),
    },
  },
}));

const footers = [
  {
    title: 'Company',
    description: ['Team', 'History', 'Contact us', 'Locations'],
  },
  {
    title: 'Features',
    description: ['Cool stuff', 'Random feature', 'Team feature', 'Developer stuff', 'Another one'],
  },
  {
    title: 'Resources',
    description: ['Resource', 'Resource name', 'Another resource', 'Final resource'],
  },
  {
    title: 'Legal',
    description: ['Privacy policy', 'Terms of use'],
  },
];

export default function Home() {
  const classes = useStyles();
  const handleClick = async (event) => {
    // When the customer clicks on the button, redirect them to Checkout.
    const stripe = await stripePromise;
    const { error } = await stripe.redirectToCheckout({
      lineItems: [{
        price: 'price_1ILFW4I92OvN7CbmGeIL0VVV', // Replace with the ID of your price
        quantity: 1,
      }],
      mode: 'subscription',
      successUrl: 'https://onboarding-b9a6e.web.app/setup',
      cancelUrl: 'https://onboarding-b9a6e.web.app',
    });
    // If `redirectToCheckout` fails due to a browser or network
    // error, display the localized error message to your customer
    // using `error.message`.
  };
  return (
    <React.Fragment>
      <CssBaseline />
    
      {/* Hero unit */}
      <Container maxWidth="sm" component="main" className={classes.heroContent}>
        <Typography component="h1" variant="h3" align="center" color="textPrimary" gutterBottom>
          Pricing done right.
        </Typography>
        <Typography variant="h5" align="center" color="textSecondary" component="p">
          We charge a flat rate of $49 per month and that is it. We don't take a cut of your business. We don't require an order minimum. 
        </Typography>
      </Container>
      {/* End hero unit */}
      <Container maxWidth="md" component="main">
      <Grid
  container
  direction="column"
  justify="center"
  alignItems="center"
>
            <center>
                 <Card className={classes.root}>
      <CardActionArea>
        <CardMedia
          className={classes.media}
          image="Grow your business.png"
          title="Aurafare Business"
        />
        <CardContent>
         <Typography gutterBottom variant="h4" component="h2">
         $49/mo
          </Typography>
         
          <Typography variant="body2" color="textSecondary" component="p">
            Connect with users, expand your business and gain realtime insight on your products.
          </Typography>
        </CardContent>
        <br/>
      </CardActionArea>
     
       <center>
          <Button size="large" color="primary" variant='contained' className={classes.purchase} onClick={handleClick}>
          Purchase
        </Button>
         <br/>
       </center>
       <br/>
       <br/>
    </Card>
            </center>
        </Grid>
      </Container>
    </React.Fragment>
  );
}